module.exports = __webpack_public_path__ + "static/media/space.88475437.jpg";